


import React from 'react';
import { motion } from 'framer-motion';
import {
  FaFacebookF,
  FaRedditAlien,
  FaInstagram,
  FaGithub,
  FaLinkedin,
} from 'react-icons/fa';

const Footer = () => {
  const socialLinks = [
    { 
      icon: <FaFacebookF />, 
      href: "https://www.facebook.com/notemasterRJ/", 
      label: "Facebook",
      hoverClass: "hover:bg-primary-600",
      focusClass: "focus:ring-primary-500"
    },
    { 
      icon: <FaRedditAlien />, 
      href: "https://www.reddit.com/user/marquinhodecastro/", 
      label: "Reddit",
      hoverClass: "hover:bg-orange-600",
      focusClass: "focus:ring-orange-500"
    },
    { 
      icon: <FaInstagram />, 
      href: "https://www.instagram.com/", 
      label: "Instagram",
      hoverClass: "hover:bg-pink-600",
      focusClass: "focus:ring-pink-500"
    },
    { 
      icon: <FaGithub />, 
      href: "https://github.com/", 
      label: "GitHub",
      hoverClass: "hover:bg-gray-600",
      focusClass: "focus:ring-gray-500"
    },
    { 
      icon: <FaLinkedin />, 
      href: "https://www.linkedin.com/", 
      label: "LinkedIn",
      hoverClass: "hover:bg-blue-600",
      focusClass: "focus:ring-blue-500"
    },
  ];

  return (
    <footer className="bg-gradient-to-b from-black via-gray-900 to-black 
                      text-gray-300 px-4 xs:px-5 sm:px-6 md:px-8 lg:px-12 
                      py-8 xs:py-10 sm:py-12 md:py-16 overflow-hidden relative">
      {/* Decoração sutil de fundo */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/5 
                     via-transparent to-primary-900/5 pointer-events-none"></div>
      
      <div className="container-responsive relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 xs:gap-8 
                     sm:gap-10 md:gap-12"
        >
          {/* Coluna 1: Sobre */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-center sm:text-left"
          >
            <h3 className="text-white text-base xs:text-lg sm:text-xl font-semibold 
                          mb-3 xs:mb-4">
              Sobre
            </h3>
            <p className="text-xs xs:text-sm sm:text-base mb-2 text-gray-400 leading-relaxed">
              Com mais de uma década de experiência, nos tornamos referência em 
              soluções técnicas aplicadas em eletrônica e informática.
            </p>
            <p className="text-xs xs:text-sm sm:text-base">
              Saiba mais sobre a{' '}
              <a
                href="/sobre"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-400 hover:text-primary-300 underline 
                          transition-colors font-medium"
              >
                Notemaster
              </a>
            </p>
          </motion.div>

          {/* Coluna 2: Links úteis */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-center sm:text-left"
          >
            <h3 className="text-white text-base xs:text-lg sm:text-xl font-semibold 
                          mb-3 xs:mb-4">
              Links úteis
            </h3>
            <ul className="space-y-1.5 xs:space-y-2 text-xs xs:text-sm sm:text-base">
              {[
                { path: '/sobre', label: 'Sobre nós' },
                { path: '/contato', label: 'Contato' },
                { path: '/termos', label: 'Termos de uso' },
              ].map((link, index) => (
                <motion.li
                  key={link.path}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: 0.3 + index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <a 
                    href={link.path} 
                    className="text-gray-400 hover:text-white transition-colors 
                              inline-block hover:translate-x-1 duration-200"
                  >
                    {link.label}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Coluna 3: Redes Sociais */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-center sm:text-left min-w-0"
          >
            <h3 className="text-white text-base xs:text-lg sm:text-xl font-semibold 
                          mb-3 xs:mb-4">
              Redes Sociais
            </h3>
            <div className="flex flex-wrap gap-3 xs:gap-4 sm:gap-5 justify-center 
                          sm:justify-start items-center">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-8 h-8 xs:w-10 xs:h-10 sm:w-12 sm:h-12 flex items-center 
                            justify-center rounded-lg bg-gray-800 ${social.hoverClass} 
                            text-white transition-all duration-300
                            focus:outline-none focus:ring-2 ${social.focusClass}
                            text-base xs:text-lg sm:text-xl shadow-soft hover:shadow-medium`}
                  aria-label={social.label}
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{ scale: 1.15, rotate: 5 }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 0.4 + index * 0.1,
                    type: "spring",
                    stiffness: 200
                  }}
                  viewport={{ once: true }}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </motion.div>
        </motion.div>

        {/* Copyright */}
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-6 xs:mt-8 sm:mt-10 md:mt-12 pt-6 xs:pt-8 
                    border-t border-gray-800"
        >
          <p className="text-xs xs:text-sm text-gray-500 break-words">
            &copy; {new Date().getFullYear()}{' '}
            <a
              href="https://www.facebook.com/notemasterRJ/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-400 hover:text-primary-300 underline 
                        transition-colors font-medium"
            >
              notemaster
            </a>
            . Todos os direitos reservados.
          </p>
          <p className="text-xs xs:text-sm text-gray-500 break-words mt-2">
            Desenvolvido por{' '}
            <a
              href="https://www.reddit.com/user/marquinhodecastro/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-400 hover:text-primary-300 underline 
                        transition-colors font-medium"
            >
              Marco de Castro
            </a>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
